// Bilingual UI strings (IT / EN). Structure ready to add more languages later.
export const translations = {
  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      projects: "Progetti",
      interdanza: "Interdanza",
      arteNatura: "Arte & Natura",
      archive: "Archivio",
      news: "Novità",
      gallery: "Gallery",
      contact: "Contatti",
    },
    common: {
      discover: "Scopri di più",
      readMore: "Leggi tutto",
      allProjects: "Tutti i progetti",
      current: "In corso",
      pastEditions: "Edizioni passate",
      backHome: "Torna alla home",
      support: "Sostienici",
      since: "Dal 2008",
    },
    home: {
      kicker: "Associazione Interculturale",
      title: "L'arte che unisce le culture",
      subtitle:
        "danza · musica · teatro · arti visive · fotografia",
      lead:
        "arts4all promuove e incentiva attività socio-culturali riferite alle arti, per diffondere l'incontro e la conoscenza reciproca di tradizioni culturali diverse.",
      ctaProjects: "Esplora i progetti",
      ctaAbout: "Chi siamo",
      statsEvents: "Eventi & spettacoli",
      statsYears: "Anni di attività",
      statsArtists: "Artisti coinvolti",
      statsEditions: "Edizioni Interdanza",
      whatTitle: "Cosa facciamo",
      whatLead:
        "Operiamo nel settore della cultura e dello spettacolo con eventi, formazione e convegni.",
      discipline1: "Danza",
      discipline1d: "Classica e contemporanea, workshop e gala internazionali.",
      discipline2: "Musica",
      discipline2d: "Concerti di musica classica e contemporanea con ospiti internazionali.",
      discipline3: "Teatro",
      discipline3d: "Spettacoli, regie e messe in scena in collaborazione con enti del territorio.",
      discipline4: "Arti Visive",
      discipline4d: "Belle arti, fotografia ed esposizioni dedicate all'arte e alla natura.",
      projectsTitle: "I nostri progetti principali",
      projectsLead: "Percorsi culturali che crescono edizione dopo edizione.",
      missionTitle: "La nostra missione",
      missionText:
        "Promuovere la pratica e la conoscenza della musica, della danza, delle arti figurative ed espressive e della cultura in senso lato. Vogliamo offrire ai giovani l'opportunità di partecipare a stages, workshop e spettacoli con Maestri di grande spessore ed esperienza, proponendo valori come studio, impegno, costanza e dedizione.",
      newsTitle: "Dall'archivio",
      novitaLabel: "Novità",
      fioriContestSoon: "Concorso fotografico «Racconta un fiore»: regolamento disponibile, modulo d'iscrizione dal 15 novembre",
      fioriRulesDownload: "Scarica il regolamento (PDF)",
      fioriRulesRead: "Leggi il regolamento",
      fioriInProject: "Nel progetto",
      fioriCta: "Scopri il progetto Fiori",
    },
    about: {
      title: "Chi siamo",
      lead:
        "\"arts4all – Associazione Interculturale\" senza scopo di lucro nasce nel Novembre 2008 da un'idea di Eva Kosa, ballerina e coreografa.",
      p1:
        "L'associazione nasce con la finalità di diffondere ed incentivare l'incontro e la conoscenza reciproca di tradizioni culturali diverse e favorirne l'integrazione, utilizzando come strumento principale il linguaggio dell'arte.",
      p2:
        "Per la fondazione, Eva Kosa si è avvalsa della collaborazione di alcuni amici esperti di musica classica e contemporanea, teatro e arti figurative, con i quali ha collaborato alla messa in scena del musical \"Aggiungi un posto a tavola\", rappresentato tra il 2005 e il 2007 in varie piazze della Toscana in collaborazione con importanti ONLUS.",
      foundersTitle: "Soci fondatori",
      foundersLead: "Le persone che hanno dato vita all'associazione nel 2008.",
      boardTitle: "Consiglio Direttivo",
      boardLead: "L'attuale consiglio direttivo dell'associazione.",
      collabsTitle: "Collaborazioni",
      collabsLead: "Le realtà artistiche con cui collaboriamo.",
      collabsVisit: "Visita il sito",
      statuteTitle: "Statuto",
      statuteText: "Consulta lo statuto ufficiale dell'associazione arts4all.",
      statuteBtn: "Scarica lo statuto (PDF)",
    },
    interdanza: {
      title: "Interdanza",
      kicker: "Progetto didattico-culturale · dal 2013",
      lead:
        "Interdanza è il progetto di danza di arts4all: workshop, stages con docenti internazionali, audizioni e un grande Gala conclusivo al Teatro Goldoni di Livorno.",
      currentTitle: "Interdanza 2026 — 14ª Edizione",
      currentDates: "gennaio / maggio 2026",
      currentText:
        "Un percorso da gennaio a maggio con workshop di danza classica (repertorio Don Quixote) e contemporanea, stages con docenti internazionali, audizione per l'International Ballet Company Messapica e il Gala internazionale \"Sulle ali della danza\".",
      programTitle: "Programma & attività",
      editionsTitle: "Le edizioni",
      externalNote: "Tutte le info su interdanza.it",
      visitSite: "Visita interdanza.it",
    },
    arteNatura: {
      title: "Arte & Natura",
      kicker: "Progetto Arte & Natura · Livorno",
      lead:
        "Il progetto culturale di arts4all dedicato al dialogo tra arte e natura, per sensibilizzare sul rispetto dell'ambiente, sulla biodiversità e sui cambiamenti climatici.",
      overviewTitle: "Il progetto",
      overviewP1:
        "Arte & Natura è il progetto culturale multidisciplinare di arts4all dedicato al dialogo tra arte e natura. Edizione dopo edizione intreccia danza, fotografia, musica, arti visive e divulgazione per raccontare la bellezza e la fragilità del mondo naturale e il legame profondo che unisce l'essere umano all'ambiente.",
      overviewP2:
        "Ogni edizione sceglie un elemento della natura come filo conduttore — il bosco, il mare, i fiori — e lo esplora attraverso linguaggi artistici diversi, coinvolgendo artisti del territorio, scuole, istituzioni e cittadini. Un percorso che cresce nel tempo, trasformando ogni luogo in un'esperienza condivisa tra arte, natura e comunità.",
      objectivesTitle: "Gli obiettivi",
      objectives: [
        "Valorizzare il patrimonio naturale e culturale del territorio.",
        "Sensibilizzare sul valore della biodiversità e sul rispetto dell'ambiente.",
        "Creare un dialogo tra arte e scienza.",
        "Avvicinare il pubblico — bambini, giovani e famiglie — al mondo naturale.",
        "Valorizzare artisti e professionisti del territorio e le scuole di danza.",
        "Creare una rete tra istituzioni, associazioni, artisti e cittadini.",
      ],
      eventsTitle: "Gli appuntamenti",
      eventsSubtitle: "Edizione 2023",
      artist: "Artista",
      collabLabel: "In collaborazione con",
      teamTitle: "Team artistico",
      activitiesTitle: "Attività principali",
      exhibitionsLabel: "Esposizioni",
      fioriJourneyTitle: "Un viaggio tra natura e arte",
      fioriContestTitle: "Concorso fotografico",
      fioriBooksTitle: "Due libri",
      fioriVenueLabel: "Sede espositiva",
      patrocinio: "Arte & Natura è patrocinato dalla Provincia e dal Comune di Livorno.",
    },
    archive: {
      title: "Archivio",
      lead:
        "Una selezione degli eventi, spettacoli e concerti realizzati dall'associazione negli anni.",
      interdanzaTitle: "Edizioni Interdanza",
    },
    news: {
      title: "Novità",
      lead: "Gli appuntamenti e i progetti attualmente in corso.",
    },
    gallery: {
      title: "Gallery",
      lead: "Immagini dai nostri spettacoli, concerti e progetti.",
    },
    contact: {
      title: "Contatti",
      lead: "Scrivici per informazioni su progetti, workshop e collaborazioni.",
      officeTitle: "Sede legale",
      office: "via Puini, Livorno\n57128, LI, Italia",
      email: "Email",
      pec: "PEC",
      phone: "Tel. ufficio",
      vat: "C.F. e P.IVA",
      formTitle: "Inviaci un messaggio",
      name: "Nome e cognome",
      emailField: "Email",
      subject: "Oggetto",
      message: "Messaggio",
      send: "Invia messaggio",
      sending: "Invio in corso...",
      success: "Grazie! Il tuo messaggio è stato inviato.",
      error: "Si è verificato un errore. Riprova.",
      donationsTitle: "Sostieni l'associazione",
      donationsText: "Le tue donazioni ci aiutano a portare l'arte a tutti.",
      newsletterTitle: "Iscriviti alla newsletter",
      newsletterText: "Non perderti mai un aggiornamento.",
      newsletterBtn: "Iscriviti",
      newsletterOk: "Iscrizione avvenuta con successo!",
      newsletterConsent: "Acconsento al trattamento dei miei dati per ricevere la newsletter, secondo la",
      newsletterConsentLink: "Privacy Policy",
      newsletterConsentError: "Devi accettare la Privacy Policy per iscriverti.",
      consent: "Ho letto e accetto il trattamento dei miei dati per rispondere alla mia richiesta, secondo la",
      consentLink: "Privacy Policy",
    },
    footer: {
      tagline: "Associazione Interculturale · dal 2008",
      about:
        "Promuoviamo l'incontro tra culture attraverso danza, musica, teatro e arti visive.",
      quickLinks: "Link rapidi",
      followUs: "Seguici",
      rights: "Tutti i diritti riservati.",
    },
    cookie: {
      banner:
        "Questo sito utilizza solo cookie e archiviazione tecnici, necessari al funzionamento del sito (es. la lingua scelta). Non utilizziamo cookie di profilazione o di terze parti.",
      accept: "Accetto",
      more: "Cookie Policy",
      pageTitle: "Cookie & Privacy Policy",
      pageLead: "Informativa sull'uso dei cookie e sul trattamento dei dati.",
      s1t: "Cosa sono i cookie",
      s1: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.",
      s2t: "Cookie utilizzati da questo sito",
      s2: "Questo sito utilizza esclusivamente cookie e strumenti di archiviazione tecnici e funzionali, necessari al corretto funzionamento del sito — ad esempio per ricordare la lingua selezionata (italiano/inglese). Non vengono utilizzati cookie di profilazione né cookie di terze parti a scopo pubblicitario.",
      s3t: "Dati dei moduli di contatto e newsletter",
      s3: "I dati che inserisci volontariamente nei moduli di contatto e di iscrizione alla newsletter (nome, email, messaggio) vengono utilizzati esclusivamente per rispondere alle tue richieste e per inviarti aggiornamenti sulle attività dell'associazione. I dati non vengono ceduti a terzi.",
      s4t: "Gestione dei cookie",
      s4: "Puoi gestire o disabilitare i cookie tecnici tramite le impostazioni del tuo browser. La disabilitazione di alcuni cookie potrebbe compromettere alcune funzionalità del sito.",
      s5t: "Titolare del trattamento",
      s5: "Titolare del trattamento è arts4all – Associazione Interculturale, via Puini, 57128 Livorno (LI). Per qualsiasi richiesta relativa ai tuoi dati puoi scriverci all'indirizzo email indicato nella pagina Contatti.",
      rightsTitle: "I tuoi diritti (GDPR)",
      rightsIntro: "In base al Regolamento UE 2016/679 (GDPR) puoi esercitare in qualsiasi momento i seguenti diritti sui tuoi dati personali:",
      rights: [
        "Accesso: ottenere conferma e una copia dei dati che ti riguardano.",
        "Rettifica: correggere dati inesatti o incompleti.",
        "Cancellazione: chiedere la cancellazione dei tuoi dati (\u201cdiritto all'oblio\u201d).",
        "Limitazione: limitare il trattamento dei tuoi dati in determinati casi.",
        "Portabilità: ricevere i tuoi dati in un formato strutturato e leggibile.",
        "Opposizione: opporti al trattamento per motivi legittimi.",
        "Revoca del consenso: revocare in qualsiasi momento il consenso prestato, ad esempio per la newsletter.",
        "Reclamo: proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
      ],
      rightsOutro: "Per esercitare questi diritti o revocare il consenso, scrivici all'indirizzo email indicato nella pagina Contatti. Risponderemo nei termini previsti dalla legge.",
    },
    privacy: {
      pageTitle: "Privacy & Cookie Policy",
      pageLead: "Informativa sul trattamento dei dati personali ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR).",
      whyTitle: "Perché questo avviso",
      why: [
        "In questa pagina si descrivono le modalità di gestione del sito dell'Associazione Culturale arts4all in riferimento al trattamento dei dati personali degli utenti che vi accedono e navigano. Si tratta di un'informativa resa ai sensi dell'art. 13 del Regolamento UE 2016/679 («GDPR») e della normativa italiana vigente (d.lgs. 196/2003 e successive modifiche, incluso il d.lgs. 101/2018).",
        "La presente policy riguarda esclusivamente il sito dell'associazione arts4all e non i siti di terzi eventualmente raggiungibili tramite collegamenti (link).",
      ],
      sections: [
        {
          title: "1. Il Titolare del trattamento",
          body: [
            "Il Titolare del trattamento è l'Associazione Culturale Arts4all, con sede legale in Via Puini 87, 57128 Livorno (LI), C.F. e P.IVA 01615210497, email info.arts4all@yahoo.com, tel. +39 392 7273083 / +39 0586 502371, in persona del suo legale rappresentante. Il Titolare non ha nominato un responsabile della protezione dei dati (DPO).",
          ],
        },
        {
          title: "2. Dato personale e trattamento",
          body: [
            "Per «dato personale» si intende qualsiasi informazione idonea a identificare, direttamente o indirettamente, una persona fisica. Per «trattamento» si intende qualsiasi operazione svolta sui dati personali (raccolta, registrazione, organizzazione, conservazione, consultazione, uso, comunicazione, cancellazione, ecc.), con o senza l'ausilio di strumenti automatizzati.",
          ],
        },
        {
          title: "3. Quali dati trattiamo",
          body: [
            "Dati di navigazione — I sistemi informatici del sito acquisiscono automaticamente alcuni dati la cui trasmissione è implicita nell'uso dei protocolli Internet (ad es. indirizzi IP, URI delle risorse richieste, orario della richiesta, parametri del sistema operativo e del browser). Tali dati sono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e di controllarne il corretto funzionamento, e potrebbero essere utilizzati per l'accertamento di responsabilità in caso di reati informatici ai danni del sito.",
            "Dati forniti volontariamente — L'invio di email agli indirizzi indicati sul sito, la compilazione del modulo di contatto e l'iscrizione alla newsletter comportano l'acquisizione dei dati inseriti (ad es. nome, email, messaggio), necessari a rispondere alle richieste o a inviare gli aggiornamenti richiesti.",
            "Cookie — Il sito utilizza esclusivamente cookie tecnici e strumenti di archiviazione necessari al corretto funzionamento (ad es. per ricordare la lingua selezionata). Non vengono utilizzati cookie di profilazione né cookie di terze parti a scopo pubblicitario. Puoi gestire o disabilitare i cookie dalle impostazioni del tuo browser; la disabilitazione di alcuni cookie potrebbe compromettere alcune funzionalità del sito.",
          ],
        },
        {
          title: "4. Modalità del trattamento",
          body: [
            "I dati sono trattati dal Titolare e dai membri dell'associazione autorizzati e istruiti al corretto trattamento, anche con strumenti elettronici o automatizzati, per il tempo strettamente necessario alle finalità. Sono adottate specifiche misure di sicurezza per prevenire la perdita dei dati, usi illeciti o non corretti e accessi non autorizzati. Il conferimento dei dati volontari è facoltativo, ma il rifiuto può impedire di soddisfare le tue richieste.",
          ],
        },
        {
          title: "5. Finalità del trattamento",
          body: [
            "I dati sono trattati per: (a) rispondere alle richieste inviate tramite email o modulo di contatto; (b) previo tuo consenso, inviarti la newsletter con aggiornamenti sulle attività dell'associazione; (c) adempiere a obblighi di legge, contabili e fiscali e, ove necessario, per finalità di sicurezza, prevenzione di condotte fraudolente e difesa dei diritti.",
          ],
        },
        {
          title: "6. Base giuridica del trattamento",
          body: [
            "Ai sensi dell'art. 6 del GDPR, il trattamento è lecito quando: è necessario per dare seguito alla tua richiesta (misure precontrattuali o contrattuali); è necessario per adempiere a un obbligo legale; oppure è basato sul tuo consenso espresso (ad es. per la newsletter), che puoi revocare in qualsiasi momento.",
          ],
        },
        {
          title: "7. Dove trattiamo i tuoi dati",
          body: [
            "Il sito è ospitato su server all'interno dell'Unione Europea e, di regola, i dati non vengono trasferiti al di fuori dell'UE. Per l'invio delle email (ad es. l'email di benvenuto alla newsletter) il Titolare può avvalersi di fornitori di servizi; qualora un trattamento comporti un trasferimento verso Paesi terzi, il Titolare garantisce adeguate garanzie ai sensi del GDPR (ad es. decisione di adeguatezza o clausole contrattuali standard approvate dalla Commissione Europea).",
          ],
        },
        {
          title: "8. Per quanto tempo conserviamo i tuoi dati",
          body: [
            "I dati sono conservati per il tempo strettamente necessario al conseguimento delle finalità per cui sono stati raccolti e, successivamente, per il tempo in cui il Titolare è soggetto a obblighi di conservazione (ad es. fiscali) o di legge, salvo opposizione al trattamento o revoca del consenso prestato.",
          ],
        },
        {
          title: "9. Ambito di comunicazione e diffusione",
          body: [
            "I dati possono essere comunicati ai membri e collaboratori dell'associazione autorizzati al trattamento e, ove necessario per le finalità indicate o per obblighi di legge, a soggetti esterni (ad es. istituti bancari, studi commercialisti o legali, fornitori di servizi informatici e di invio email, autorità giudiziarie o amministrative). I dati non vengono diffusi né ceduti a terzi per finalità commerciali.",
          ],
        },
        {
          title: "10. Processo decisionale automatizzato",
          body: [
            "Il Titolare non adotta alcun processo decisionale automatizzato, compresa la profilazione, di cui all'art. 22 del GDPR.",
          ],
        },
        {
          title: "11. Dati di minori",
          body: [
            "Il trattamento dei dati di un minore è lecito se il minore ha almeno 16 anni; al di sotto di tale età è necessario il consenso di chi esercita la responsabilità genitoriale. Il Titolare richiede a chi utilizza i canali di contatto del sito di avere almeno 16 anni.",
          ],
        },
        {
          title: "12. Dati particolari",
          body: [
            "In applicazione del principio di minimizzazione (art. 5 GDPR), si chiede agli utenti di non comunicare dati particolari ex art. 9 GDPR (ad es. origine razziale o etnica, opinioni politiche, convinzioni religiose, dati relativi alla salute, ecc.). Eventuali dati di questo tipo comunicati volontariamente non verranno trattati.",
          ],
        },
      ],
      rightsTitle: "13. I tuoi diritti",
      rightsIntro: "In ogni momento puoi esercitare, ai sensi degli artt. 15–22 e 77 del GDPR, i seguenti diritti:",
      rights: [
        "Accesso: ottenere conferma dell'esistenza di un trattamento e una copia dei tuoi dati (art. 15).",
        "Rettifica: correggere dati inesatti o incompleti (art. 16).",
        "Cancellazione: ottenere la cancellazione dei tuoi dati nei casi previsti (art. 17).",
        "Limitazione: limitare il trattamento dei tuoi dati in determinati casi (art. 18).",
        "Portabilità: ricevere i tuoi dati in un formato strutturato e leggibile da dispositivo automatico (art. 20).",
        "Opposizione: opporti al trattamento per motivi legati alla tua situazione particolare (art. 21).",
        "Revoca del consenso: in qualsiasi momento, senza pregiudizio per la liceità del trattamento precedente (art. 7).",
        "Reclamo: proporre reclamo al Garante per la protezione dei dati personali (art. 77).",
      ],
      rightsHow: "Puoi esercitare gratuitamente i tuoi diritti con richiesta scritta all'Associazione Culturale Arts4all, Via Puini 87, 57128 Livorno (LI), oppure via email a info.arts4all@yahoo.com.",
      updatesTitle: "Aggiornamenti",
      updatesText: "La presente Privacy & Cookie Policy può essere soggetta ad aggiornamenti periodici in ottemperanza a disposizioni normative o regolamentari. Si consiglia di consultare periodicamente questa pagina.",
      updated: "Ultimo aggiornamento: 12/01/2026",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      projects: "Projects",
      interdanza: "Interdanza",
      arteNatura: "Art & Nature",
      archive: "Archive",
      news: "News",
      gallery: "Gallery",
      contact: "Contact",
    },
    common: {
      discover: "Discover more",
      readMore: "Read more",
      allProjects: "All projects",
      current: "Ongoing",
      pastEditions: "Past editions",
      backHome: "Back to home",
      support: "Support us",
      since: "Since 2008",
    },
    home: {
      kicker: "Intercultural Association",
      title: "The art that unites cultures",
      subtitle: "dance · music · theatre · visual arts · photography",
      lead:
        "arts4all promotes and encourages socio-cultural activities related to the arts, spreading the encounter and mutual understanding of different cultural traditions.",
      ctaProjects: "Explore projects",
      ctaAbout: "About us",
      statsEvents: "Events & shows",
      statsYears: "Years of activity",
      statsArtists: "Artists involved",
      statsEditions: "Interdanza editions",
      whatTitle: "What we do",
      whatLead:
        "We operate in the culture and performing arts sector with events, training and conferences.",
      discipline1: "Dance",
      discipline1d: "Classical and contemporary, international workshops and galas.",
      discipline2: "Music",
      discipline2d: "Classical and contemporary concerts with international guests.",
      discipline3: "Theatre",
      discipline3d: "Shows and stagings in collaboration with local institutions.",
      discipline4: "Visual Arts",
      discipline4d: "Fine arts, photography and exhibitions dedicated to art and nature.",
      projectsTitle: "Our main projects",
      projectsLead: "Cultural journeys that grow edition after edition.",
      missionTitle: "Our mission",
      missionText:
        "To promote the practice and knowledge of music, dance, figurative and expressive arts and culture in the broadest sense. We want to give young people the opportunity to take part in stages, workshops and shows with masters of great depth and experience, promoting values such as study, commitment, perseverance and dedication.",
      newsTitle: "From the archive",
      novitaLabel: "News",
      fioriContestSoon: "«Tell a flower» photo contest: rules available, registration form from 15 November",
      fioriRulesDownload: "Download the rules (PDF, Italian)",
      fioriRulesRead: "Read the rules",
      fioriInProject: "In the project",
      fioriCta: "Discover the Fiori project",
    },
    about: {
      title: "About Us",
      lead:
        "\"arts4all – Intercultural Association\", a non-profit, was born in November 2008 from an idea by Eva Kosa, dancer and choreographer.",
      p1:
        "The association was founded to spread and encourage the encounter and mutual understanding of different cultural traditions and to foster integration, using the language of art as its main tool.",
      p2:
        "For its foundation, Eva Kosa relied on the collaboration of friends who were experts in classical and contemporary music, theatre and figurative arts, with whom she staged the musical \"Aggiungi un posto a tavola\", performed between 2005 and 2007 across Tuscany with important non-profits.",
      foundersTitle: "Founding members",
      foundersLead: "The people who brought the association to life in 2008.",
      boardTitle: "Board of Directors",
      boardLead: "The current board of directors of the association.",
      collabsTitle: "Collaborations",
      collabsLead: "The artistic partners we work with.",
      collabsVisit: "Visit website",
      statuteTitle: "Statute",
      statuteText: "Read the official statute of the arts4all association.",
      statuteBtn: "Download statute (PDF)",
    },
    interdanza: {
      title: "Interdanza",
      kicker: "Educational & cultural project · since 2013",
      lead:
        "Interdanza is arts4all's dance project: workshops, stages with international teachers, auditions and a grand final Gala at the Teatro Goldoni in Livorno.",
      currentTitle: "Interdanza 2026 — 14th Edition",
      currentDates: "January / May 2026",
      currentText:
        "A journey from January to May with classical (Don Quixote repertoire) and contemporary dance workshops, stages with international teachers, an audition for the International Ballet Company Messapica and the international Gala \"Sulle ali della danza\".",
      programTitle: "Programme & activities",
      editionsTitle: "The editions",
      externalNote: "All info on interdanza.it",
      visitSite: "Visit interdanza.it",
    },
    arteNatura: {
      title: "Art & Nature",
      kicker: "Art & Nature project · Livorno",
      lead:
        "arts4all's cultural project dedicated to the dialogue between art and nature, raising awareness about respect for the environment, biodiversity and climate change.",
      overviewTitle: "The project",
      overviewP1:
        "Art & Nature is arts4all's multidisciplinary cultural project dedicated to the dialogue between art and nature. Edition after edition, it weaves together dance, photography, music, visual arts and outreach to tell the beauty and fragility of the natural world and the deep bond that unites humankind and the environment.",
      overviewP2:
        "Each edition chooses an element of nature as its guiding thread — the woods, the sea, flowers — and explores it through different artistic languages, involving local artists, schools, institutions and citizens. A journey that grows over time, turning every place into a shared experience of art, nature and community.",
      objectivesTitle: "The objectives",
      objectives: [
        "Enhance the natural and cultural heritage of the territory.",
        "Raise awareness of the value of biodiversity and respect for the environment.",
        "Create a dialogue between art and science.",
        "Bring the public — children, young people and families — closer to the natural world.",
        "Promote local artists, professionals and dance schools.",
        "Build a network between institutions, associations, artists and citizens.",
      ],
      eventsTitle: "The events",
      eventsSubtitle: "2023 edition",
      artist: "Artist",
      collabLabel: "In collaboration with",
      teamTitle: "Artistic team",
      activitiesTitle: "Main activities",
      exhibitionsLabel: "Exhibitions",
      fioriJourneyTitle: "A journey between nature and art",
      fioriContestTitle: "Photo contest",
      fioriBooksTitle: "Two books",
      fioriVenueLabel: "Exhibition venue",
      patrocinio: "Art & Nature is supported by the Province and the Municipality of Livorno.",
    },
    archive: {
      title: "Archive",
      lead:
        "A selection of the events, shows and concerts organised by the association over the years.",
      interdanzaTitle: "Interdanza editions",
    },
    news: {
      title: "News",
      lead: "Current events and ongoing projects.",
    },
    gallery: {
      title: "Gallery",
      lead: "Images from our shows, concerts and projects.",
    },
    contact: {
      title: "Contact",
      lead: "Write to us for information about projects, workshops and collaborations.",
      officeTitle: "Registered office",
      office: "via Puini, Livorno\n57128, LI, Italy",
      email: "Email",
      pec: "PEC",
      phone: "Office phone",
      vat: "Tax ID & VAT",
      formTitle: "Send us a message",
      name: "Full name",
      emailField: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sending: "Sending...",
      success: "Thank you! Your message has been sent.",
      error: "An error occurred. Please try again.",
      donationsTitle: "Support the association",
      donationsText: "Your donations help us bring art to everyone.",
      newsletterTitle: "Subscribe to the newsletter",
      newsletterText: "Never miss an update.",
      newsletterBtn: "Subscribe",
      newsletterOk: "Subscription successful!",
      newsletterConsent: "I consent to the processing of my data to receive the newsletter, according to the",
      newsletterConsentLink: "Privacy Policy",
      newsletterConsentError: "You must accept the Privacy Policy to subscribe.",
      consent: "I have read and accept the processing of my data to respond to my request, according to the",
      consentLink: "Privacy Policy",
    },
    footer: {
      tagline: "Intercultural Association · since 2008",
      about:
        "We promote the encounter between cultures through dance, music, theatre and visual arts.",
      quickLinks: "Quick links",
      followUs: "Follow us",
      rights: "All rights reserved.",
    },
    cookie: {
      banner:
        "This website only uses technical cookies and storage that are necessary for the site to work (e.g. your chosen language). We do not use profiling or third-party cookies.",
      accept: "Accept",
      more: "Cookie Policy",
      pageTitle: "Cookie & Privacy Policy",
      pageLead: "Information on the use of cookies and data processing.",
      s1t: "What cookies are",
      s1: "Cookies are small text files that the websites you visit send to your device, where they are stored and sent back to the same websites on your next visit.",
      s2t: "Cookies used by this website",
      s2: "This website only uses technical and functional cookies and storage, necessary for the correct functioning of the site — for example to remember the selected language (Italian/English). No profiling cookies or third-party advertising cookies are used.",
      s3t: "Contact form and newsletter data",
      s3: "The data you voluntarily enter in the contact and newsletter subscription forms (name, email, message) are used exclusively to respond to your requests and to send you updates about the association's activities. Data is never shared with third parties.",
      s4t: "Managing cookies",
      s4: "You can manage or disable technical cookies through your browser settings. Disabling some cookies may affect certain features of the site.",
      s5t: "Data controller",
      s5: "The data controller is arts4all – Intercultural Association, via Puini, 57128 Livorno (LI), Italy. For any request regarding your data, you can write to the email address shown on the Contact page.",
      rightsTitle: "Your rights (GDPR)",
      rightsIntro: "Under EU Regulation 2016/679 (GDPR) you may exercise the following rights over your personal data at any time:",
      rights: [
        "Access: obtain confirmation and a copy of the data concerning you.",
        "Rectification: correct inaccurate or incomplete data.",
        "Erasure: request the deletion of your data (\u201cright to be forgotten\u201d).",
        "Restriction: restrict the processing of your data in certain cases.",
        "Portability: receive your data in a structured, readable format.",
        "Objection: object to the processing for legitimate reasons.",
        "Withdrawal of consent: withdraw at any time the consent you have given, e.g. for the newsletter.",
        "Complaint: lodge a complaint with the data protection authority.",
      ],
      rightsOutro: "To exercise these rights or withdraw your consent, write to the email address shown on the Contact page. We will reply within the time limits set by law.",
    },
    privacy: {
      pageTitle: "Privacy & Cookie Policy",
      pageLead: "Information on the processing of personal data pursuant to art. 13 of EU Regulation 2016/679 (GDPR).",
      whyTitle: "Why this notice",
      why: [
        "This page describes how the website of the Cultural Association arts4all handles the processing of personal data of the users who access and browse it. This notice is provided pursuant to art. 13 of EU Regulation 2016/679 (\"GDPR\") and the Italian legislation in force (Legislative Decree 196/2003 as amended, including Legislative Decree 101/2018).",
        "This policy concerns only the website of the arts4all association and not any third-party websites that may be reached through links.",
      ],
      sections: [
        {
          title: "1. The data controller",
          body: [
            "The data controller is the Cultural Association Arts4all, with registered office at Via Puini 87, 57128 Livorno (LI), Italy, Tax ID and VAT 01615210497, email info.arts4all@yahoo.com, tel. +39 392 7273083 / +39 0586 502371, in the person of its legal representative. The controller has not appointed a Data Protection Officer (DPO).",
          ],
        },
        {
          title: "2. Personal data and processing",
          body: [
            "\"Personal data\" means any information that can identify, directly or indirectly, a natural person. \"Processing\" means any operation performed on personal data (collection, recording, organisation, storage, consultation, use, communication, erasure, etc.), with or without automated means.",
          ],
        },
        {
          title: "3. What data we process",
          body: [
            "Browsing data — The website's IT systems automatically acquire certain data whose transmission is implicit in the use of Internet protocols (e.g. IP addresses, URIs of the requested resources, time of the request, operating system and browser parameters). Such data are used solely to obtain anonymous statistical information about the use of the site and to check its correct operation, and may be used to ascertain liability in the event of computer crimes against the site.",
            "Data provided voluntarily — Sending emails to the addresses shown on the site, filling in the contact form and subscribing to the newsletter entail the acquisition of the data entered (e.g. name, email, message), necessary to respond to requests or to send the requested updates.",
            "Cookies — The site only uses technical cookies and storage necessary for its correct operation (e.g. to remember the selected language). No profiling cookies or third-party advertising cookies are used. You can manage or disable cookies via your browser settings; disabling some cookies may affect certain features of the site.",
          ],
        },
        {
          title: "4. How we process data",
          body: [
            "Data are processed by the controller and by duly authorised and instructed members of the association, also by electronic or automated means, for the time strictly necessary for the purposes. Specific security measures are applied to prevent data loss, unlawful or incorrect use and unauthorised access. Providing voluntary data is optional, but refusal may prevent us from fulfilling your requests.",
          ],
        },
        {
          title: "5. Purposes of processing",
          body: [
            "Data are processed to: (a) respond to requests sent via email or the contact form; (b) subject to your consent, send you the newsletter with updates on the association's activities; (c) comply with legal, accounting and tax obligations and, where necessary, for security purposes, fraud prevention and the defence of rights.",
          ],
        },
        {
          title: "6. Legal basis of processing",
          body: [
            "Pursuant to art. 6 of the GDPR, processing is lawful when: it is necessary to follow up on your request (pre-contractual or contractual measures); it is necessary to comply with a legal obligation; or it is based on your express consent (e.g. for the newsletter), which you may withdraw at any time.",
          ],
        },
        {
          title: "7. Where we process your data",
          body: [
            "The site is hosted on servers within the European Union and, as a rule, data are not transferred outside the EU. For sending emails (e.g. the newsletter welcome email) the controller may rely on service providers; should any processing involve a transfer to third countries, the controller ensures adequate safeguards under the GDPR (e.g. an adequacy decision or standard contractual clauses approved by the European Commission).",
          ],
        },
        {
          title: "8. How long we keep your data",
          body: [
            "Data are kept for the time strictly necessary to achieve the purposes for which they were collected and, thereafter, for the time during which the controller is subject to retention obligations (e.g. tax) or by law, unless you object to the processing or withdraw your consent.",
          ],
        },
        {
          title: "9. Scope of communication and disclosure",
          body: [
            "Data may be communicated to the association's members and collaborators authorised to process them and, where necessary for the stated purposes or for legal obligations, to external parties (e.g. banks, accounting or law firms, IT and email service providers, judicial or administrative authorities). Data are not disclosed or transferred to third parties for commercial purposes.",
          ],
        },
        {
          title: "10. Automated decision-making",
          body: [
            "The controller does not carry out any automated decision-making, including profiling, under art. 22 of the GDPR.",
          ],
        },
        {
          title: "11. Minors' data",
          body: [
            "Processing a minor's data is lawful if the minor is at least 16 years old; below that age, the consent of the holder of parental responsibility is required. The controller requires those who use the site's contact channels to be at least 16 years old.",
          ],
        },
        {
          title: "12. Special categories of data",
          body: [
            "In application of the data minimisation principle (art. 5 GDPR), users are asked not to share special categories of data under art. 9 GDPR (e.g. racial or ethnic origin, political opinions, religious beliefs, health data, etc.). Any such data shared voluntarily will not be processed.",
          ],
        },
      ],
      rightsTitle: "13. Your rights",
      rightsIntro: "At any time you may exercise the following rights, pursuant to arts. 15–22 and 77 of the GDPR:",
      rights: [
        "Access: obtain confirmation of the existence of processing and a copy of your data (art. 15).",
        "Rectification: correct inaccurate or incomplete data (art. 16).",
        "Erasure: obtain the deletion of your data in the cases provided for (art. 17).",
        "Restriction: restrict the processing of your data in certain cases (art. 18).",
        "Portability: receive your data in a structured, machine-readable format (art. 20).",
        "Objection: object to the processing for reasons relating to your particular situation (art. 21).",
        "Withdrawal of consent: at any time, without affecting the lawfulness of prior processing (art. 7).",
        "Complaint: lodge a complaint with the data protection authority (art. 77).",
      ],
      rightsHow: "You may exercise your rights free of charge by written request to the Cultural Association Arts4all, Via Puini 87, 57128 Livorno (LI), Italy, or by email to info.arts4all@yahoo.com.",
      updatesTitle: "Updates",
      updatesText: "This Privacy & Cookie Policy may be subject to periodic updates in compliance with legal or regulatory provisions. We recommend checking this page periodically.",
      updated: "Last updated: 12/01/2026",
    },
  },
};
